import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/services/auth.service';
import jwtDecode from 'jwt-decode';
import axios from 'axios';
import {GrupeDelovaVozila, Osoba, ServisnaOperacija, TrosakVozila, Vozilo} from "@/services/BackendProxies";
import dataProxy from '@/services/data-proxy.service';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loggedUser: '',
        tenantName: '',
        permissions: [],
        avatar: '',
        isSuperAdmin: false,
        vozilo: new Vozilo(),
        vozila: [],
        vrsteOdrzavanja: [],
        grupeDelova: [],
        servisneOperacije: [],
        vrsteTroskovaVozila: [],
        zaposleni: [],
        menuEnlarged: true,
        podesavanjeSistema: null
    },
    mutations: {
        setLoggedUser: (store, user) => {store.loggedUser = user},
        setTenantName: (store, tenantName) => {store.tenantName = tenantName},
        setVozilo: (store, vozilo: Vozilo) => store.vozilo = vozilo,
        setVozila: (store, vozila) => store.vozila = vozila,
        setVrsteOdrzavanja: (store, vrsteOdrzavanja) => store.vrsteOdrzavanja = vrsteOdrzavanja,
        setGrupeDelova: (store, grupeDelova) => store.grupeDelova = grupeDelova,
        setServisneOperacije: (store, servisneOperacije) => store.servisneOperacije = servisneOperacije,
        setVrsteTroskovaVozila: (store, vrsteTroskovaVozila) => store.vrsteTroskovaVozila = vrsteTroskovaVozila,
        setZaposleni: (store, zaposleni) => store.zaposleni = zaposleni,
        setMenuEnlarged: (store, isEnlarged) => store.menuEnlarged = isEnlarged,
        setPodesavanjeSistema: (store, podesavanjeSistema) => store.podesavanjeSistema = podesavanjeSistema,
        setAvatar: (store, avatar) => store.avatar = avatar,
        setPermissions: (store, permissions) => store.permissions = JSON.parse(permissions),
        setSuperAdmin: (store) => store.isSuperAdmin = true,
    },
    actions: {
        async refreshToken({commit}, refreshToken: string) {
            const data = await auth.refreshToken(refreshToken);
            if (data) {
                axios.defaults.headers["Authorization"] = `Bearer ${data.access_token}`;
                const authData = <any>jwtDecode(data.access_token);
                const user = authData['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
                commit('setLoggedUser', user);
                commit('setTenantName', authData['TenantName']);
                commit('setAvatar', authData['Avatar'])
                commit('setPermissions', authData['Permissions']);
                if (authData.sub == -1) {
                    commit('setSuperAdmin');
                }
                return data.access_token;
            }
        },
        async sacuvajVozilo({commit}, vozilo: Vozilo) {
            const id = await dataProxy.sacuvajVozilo(vozilo);
            vozilo.id = id;
            commit('setVozilo', vozilo);
            return id;
        },
        async preloadData({ commit }) {
            const vozila = await dataProxy.vratiVozilaKorisnika();
            const v = vozila.map(v => ({id: v.id.toString(), text: v.registarskaOznaka, kategorija: v.kategorijaVozilaId}));
            v.unshift({id: '', text: '...', kategorija: 0});
            commit('setVozila', v);

            const vrsteOdrzavanja = await dataProxy.vratiVrsteOdrzavanja();
            const v1 = vrsteOdrzavanja.map(v => ({id: v.id.toString(), text: v.oznaka}));
            v1.unshift({id: '', text: '...'});
            commit('setVrsteOdrzavanja', v1);

            const grupeDelova =  (await dataProxy.vratiGrupeDelovaVozila())
                .filter(x => x.korektivnoOdrzavanjeId != undefined || x.preventivnoOdrzavanjeId != undefined);
            grupeDelova.unshift(GrupeDelovaVozila.fromJS({id: '', oznaka: '...'}));
            const gd = grupeDelova.map(gd => ({
                id: gd.id,
                text: `${gd.oznaka} ${gd.naziv || ''}`,
                preventivnoOdrzavanjeId: gd.preventivnoOdrzavanjeId,
                korektivnoOdrzavanjeId: gd.korektivnoOdrzavanjeId
            }));
            commit('setGrupeDelova', gd);

            const servisneOperacije = await dataProxy.vratiServisneOperacije();
            servisneOperacije.unshift(ServisnaOperacija.fromJS({id: '', naziv: '...'}));
            const sv = servisneOperacije.map(sv => ({
                id: sv.id,
                text: `${sv.naziv}` || '',
                grupaDelovaVozilaId: sv.grupaDelovaVozilaId
            }));
            commit('setServisneOperacije', sv);

            const vrsteTroskovaVozila = await dataProxy.vratiTroskoveVozila();
            vrsteTroskovaVozila.unshift(TrosakVozila.fromJS({id: '', naziv: '...'}));
            const vt = vrsteTroskovaVozila.map(vt => ({
                id: vt.id,
                text: vt.naziv,
                vrstaOdrzavanjaId: vt.vrstaOdrzavanjaId,
                naziv: vt.naziv
            }));
            commit('setVrsteTroskovaVozila', vt);

            const zaposleni = await dataProxy.vratiPripadajuceOsobe();
            zaposleni.unshift(Osoba.fromJS({id: '', ime: '...', prezime: ''}));
            const zaposlen = zaposleni.map(zp => ({
                id: zp.id,
                text: `${zp.ime} ${zp.prezime}`
            }));
            commit('setZaposleni', zaposlen);

            const podesavanjeSistema = await dataProxy.vratiPodesavanjeSistema();
            commit('setPodesavanjeSistema', podesavanjeSistema);
        }
    }
})
